import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';

import { ProductService } from 'src/app/services/product.service';
import { downloads } from 'src/app/shared/utils/calsoft-validators';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-course-pdf-upload',
  templateUrl: './course-pdf-upload.component.html',
  styleUrls: ['./course-pdf-upload.component.scss']
})
export class CoursePdfUploadComponent  implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  text: string;
  public serverPath = environment.commonImageApi + 'coursepdf/';
  value: any;

  @Input() finalValue: any;

  @Output() sendValue = new EventEmitter();
  constructor(
    private snackBar: MatSnackBar,
    private productService: ProductService, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {
    this.text = "Save"
    this.value= this.finalValue;
  }
  imageVisible: boolean = true;
  imageDelete: boolean;
  imagesToRemoved: any = [];
 
  deleteImage(i) {
    this.imageVisible = false;
    this.imageDelete = true;
    let smallImage = "/courseImage/" + this.finalValue;
    this.imagesToRemoved.push(smallImage);

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save"
          this.imageVisible = false;
          this.imageDelete = false;
          
        }
        else {
          this.imageVisible = true;
          this.imageDelete = false;
          this.finalValue='';
  
          
    this.sendValue.emit(this.finalValue);
          this.text = "Save"
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.imageVisible = true;
      });

  }

  getResult(event) {
    this.imageVisible = true;

    this.finalValue=event.productEntityMediaGallery[0].fileName
   
    this.value= this.finalValue;

    this.sendValue.emit(this.value);
  }
  cancelUpload() {
    this.imageVisible = true;
  }

  logo() {
    this.imageVisible = false;
  }



  download() {
    let smallImage = "/coursepdf/" + this.finalValue;
    this.productService.downloadPdf(smallImage).subscribe(
      data => {
        downloads(data);
      })
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
